import Menu from "./components/Menu";
import "./App.css"
function App() {
  return <Menu />;
}
export default App;
